import React from 'react';
import { Typography } from 'antd';
import './page.css';

const { Title, Text } = Typography;

/**
 * The one page heading: Title level 3, weight 700, secondary subtitle, actions on the right
 * (wrapping on narrow screens). `branding` (Commandment VIII) adds the company logo, font and
 * title colour; the logo URL is rendered exactly as supplied.
 */
const PageHeader = ({ title, subtitle, back, actions, status, branding, children }) => (
  <div
    className="pl-page-header"
    data-testid="page-header"
    style={branding?.fontFamily ? { fontFamily: branding.fontFamily } : undefined}
  >
    <div className="pl-page-header__lead">
      {back ? <div className="pl-page-header__back" data-testid="page-header-back">{back}</div> : null}
      {branding?.logoUrl ? (
        <img src={branding.logoUrl} alt="Company logo" data-testid="branding-logo" className="pl-page-header__logo" />
      ) : null}
      <div className="pl-page-header__text">
        <div className="pl-page-header__titleRow">
          <Title level={3} className="pl-page-title" style={branding?.primaryColor ? { color: branding.primaryColor } : undefined}>
            {title}
          </Title>
          {status ? <span data-testid="page-header-status">{status}</span> : null}
        </div>
        {subtitle ? <Text type="secondary" style={{ display: 'block' }}>{subtitle}</Text> : null}
        {children}
      </div>
    </div>
    {actions ? <div className="pl-page-header__actions" data-testid="page-header-actions">{actions}</div> : null}
  </div>
);

export default PageHeader;
